module.exports = __webpack_public_path__ + "static/img/1-1.807337a7.jpg";